import React from 'react';
import PropTypes from 'prop-types';
import PresetTableRow from './preset_table_row';

import './styles/preset_table.scss';

const PresetTable = ({
  items,
  onPresetChange,
}) => {
  const listItems = items.map(({
    id,
    name,
    aspect_width,
    aspect_height,
    width,
    height,
    format,
  }) => (
    <PresetTableRow
      id={id}
      name={name}
      aspectWidth={aspect_width}
      aspectHeight={aspect_height}
      width={width}
      height={height}
      format={format}
      key={id}
      onRemove={onPresetChange}
    />
  ));

  return (
    <ul className="cropping--preset-table">
      <li className="header">
        <span>Name</span>
        <span>Aspect Ratio</span>
        <span>Width (px)</span>
        <span>Height (px)</span>
        <span>Filetype</span>
        <span />
      </li>
      {listItems}
    </ul>
  );
};

PresetTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    aspect_width: PropTypes.number,
    aspect_height: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    format: PropTypes.string,
  })),
  onPresetChange: PropTypes.func,
};

PresetTable.defaultProps = {
  items: [],
  onPresetChange: () => {},
};

export default PresetTable;
